













































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { TSchoolForm } from '@/types/views/educational.d.ts';
import { getSchoolInfo } from '@/api/educational.ts';
@Component({})
export default class Search extends Vue {
  private form: TSchoolForm = {
    name: '',
    address: '',
    teacherNo: '',
    contactname: '',
    contactphone: '',
    adminemail: ''
  };
  private activated () {
    this.getSchoolInfo()
  }
  private async getSchoolInfo() {
    try {
      this.form = await getSchoolInfo()
    } catch (e) {
      this.$message.error(e.message)
    }
  }
}
